'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Drawer", {
    enumerable: true,
    get: function() {
        return Drawer;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _drawerContext = require("../../contexts/drawerContext");
const _useDrawer = require("./useDrawer");
const _renderDrawer = require("./renderDrawer");
const _useDrawerStylesstyles = require("./useDrawerStyles.styles");
const Drawer = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDrawer.useDrawer_unstable)(props, ref);
    const contextValue = (0, _drawerContext.useDrawerContextValue)();
    (0, _useDrawerStylesstyles.useDrawerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerStyles_unstable')(state);
    return (0, _renderDrawer.renderDrawer_unstable)(state, contextValue);
});
Drawer.displayName = 'Drawer';
